import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';

interface PublicEvetnsViewProps {
	onChanged: (event: PublicEventItem) => void;
	value?: string;
	label: string;
	required?: boolean;
	mode: ControlMode;
}

@observer
export class PublicEventsEditorView extends React.Component<PublicEvetnsViewProps, { options: any[], item?: PublicEventItem }> {
	constructor(props) {
		super(props);

		this.state = {
			options: [],
			item: null
		}
	}

	@resolve
	protected reflectionService: RulesReflectionService;

	public componentDidMount() {
		this.reflectionService.getPublicEvents().then(events => {
			this.setState({ options: events }, () => {

				var opt = this.state.options.find((value: PublicEventItem, index) => value.classPath === this.props.value);

				if (opt)
					this.setState({ item: opt });
			});
			

		});
	}
	
	@autobind
	protected onEventSelect(item: any) {
		this.setState({ item });
		this.props.onChanged(item);
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Event';
		}

		return (<div>
					<DropdownView
						label={label}
						model={this.props.value}
						required={this.props.required}
						disabled={this.props.mode == 'display'}
						onChanged={this.onEventSelect}
						options={this.state.options}
						keyField='classPath'
						textField='displayName'
					/>
					{ this.state.item && <div>
							<h3>Description: </h3>
							<p>{this.state.item.description}</p>
							<h4>Available event properties: </h4>
							<ul>
					{this.state.item.properties.map((item, index) => {
						return <li key={item.propertyName}>{item.propertyName}  {item.description && ('(' + item.description + ')')}</li>
					})}
							</ul>
						</div>
					}
				</div>);;
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/parts/public-events-editor.view.tsx